module.exports = __webpack_public_path__ + "img/pxj_pixeljourney.7a1121a.png";